/** @jsxRuntime classic */
/** @jsx jsx */
import { memo, useRef, useMemo, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@emotion/core';
import OptionWrapper from "../others/option-wrapper";
import { classNames } from "../../utils";
const CardFooter = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  action = {},
  children,
  className,
  id,
  style,
  title
}, reference) => {
  const ref = useRef(null);
  useImperativeHandle(reference, () => {
    const currentRef = ref.current || {};
    currentRef.element = ref.current;
    const _instance = {
      ...action
    }; // methods
    _instance.__proto__ = {}; // hidden methods
    currentRef.instance = _instance;
    return currentRef;
  });
  return useMemo(() => {
    return jsx("div", {
      id: id,
      ref: ref,
      style: style,
      className: classNames(`DGN-UI-Card-Footer`, className)
    }, children);
  }, [children, className, id, style, title]);
}));
CardFooter.defaultProps = {
  className: '',
  style: {}
};
CardFooter.propTypes = {
  /** The content of the component. */
  children: PropTypes.node,
  /** Class for component. ({container: '', header: '', body: '', footer: ''}) */
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /** If `true`, will have divider between body and footer. */
  style: PropTypes.object,
  /** The title of the component's header. */
  title: PropTypes.string
};
export { CardFooter };
export default OptionWrapper(CardFooter);